import { composeApiURL } from "helpers/utility/axiosHelpers";
import { useMemo } from "react";
import { useLocation } from "react-router";

const GoogleButton = () => {
  const location = useLocation();
  const searchParams = useMemo(
    () => new URLSearchParams(location.search),
    [location.search]
  );
  let loginURI = composeApiURL(
    process.env.REACT_APP_API_ENDPOINT!,
    `/google-sso`
  );
  if (searchParams.get("next")) {
    loginURI = loginURI + "?next=" + searchParams.get("next");
  }
  if (searchParams.get("access_code")) {
    loginURI +=
      (loginURI.includes("?") ? "&" : "?") +
      "access_code=" +
      encodeURIComponent(searchParams.get("access_code") as string);
  }
  return (
    <div
      id="g_id_onload"
      data-client_id={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      data-context="signin"
      data-ux_mode="popup"
      data-login_uri={loginURI}
      data-nonce=""
      data-auto_prompt="false"
    ></div>
  );
};
export default GoogleButton;
